import React from 'react';

const Deals = () => {
    return (
        <div className="container">
            <h1>This is Deals component</h1>
        </div>
    );
};

export default Deals;